
const style = (theme) => {
  const output = {
    root: {
      minHeight: '100vh',
      '&.arte': {
        background: theme.colors[8],
        color: theme.colors[1],
        '& $content': {
          background: theme.colors[8],
          color: theme.colors[1],
        },
      },
    },
    content: {
      background: theme.colors[1],
      color: theme.colors[0],
    },
    wrapper: {
      extend: theme.wrapper,
    },
    link: {
      marginTop: 20,
      display: 'inline-block',
    },
    linkBox: {
      extend: theme.wrapper,
      paddingBottom: 200,
      paddingTop: 100,
      fontSize: 24,
      '& a': {
        color: 'inherit',
        textDecoration: 'underline',
        textTransform: 'none',
      },
    },
    description: {
      extend: theme.wrapper,
      paddingTop: 200,
      paddingBottom: 200,
      fontSize: 24,
    },
    products: {
      paddingTop: 50,
    },
    gallery: {
      marginBottom: 100,
    },
    productsTitle: {
      textTransform: 'uppercase',
      fontSize: 24,
      marginBottom: 50,
    },
    imageCaption: {
      textAlign: 'right',
      fontSize: 12,
      display: 'block',
      marginTop: 10,
      fontStyle: 'italic',
    },
  }

  /*------------------------------
  SM
  ------------------------------*/
  output[theme.mediaInverse.sm] = {
    description: {
      paddingTop: 50,
      paddingBottom: 50,
      fontSize: 16,
    },
    productsTitle: {
      fontSize: 16,
      marginBottom: 20,
    },
  }

  return output
}

export default style
